import {createAsyncThunk} from "@reduxjs/toolkit";
import {client} from "../../_api/client";
import {RECEIPT} from "./initState";


export const getPayments = createAsyncThunk(
    `${RECEIPT}/getPayments`,
    async () => {
        const response = await client.get('/payment/allForStudent')
        return response.data
    }
)

export const getPaymentsForTeacher = createAsyncThunk(
    `${RECEIPT}/getPayments`,
    async () => {
        const response = await client.get('/payment/allForTeacher')
        return response.data
    }
)

export const confirmPayment = createAsyncThunk(
    `${RECEIPT}/confirmPayment`,
    async (body) => {
        const response = await client.post('/payment/confirm', body)
        return response.data
    }
)

export const sendReceipt = createAsyncThunk(
    `${RECEIPT}/sendReceipt`,
    async (body) => {
        const response = await client.post('/receipt/upload', body)
        return response.data
    }
)

export const deletePayment = createAsyncThunk(
    `${RECEIPT}/deletePayment`,
    async (id) => {
        const response = await client.delete(`/payment/${id}`)
        return response.data
    }
)